import ReportSections from './../../../constants/ReportSections';

const EditableReportSections = {
    STRONG_POINTS: ReportSections.STRONG_POINTS,
    POINTS_OF_ATTENTION: ReportSections.POINTS_OF_ATTENTION,
    COMPETENCY_PROFILE: ReportSections.COMPETENCY_PROFILE,
    SELECTION_ADVICE: ReportSections.SELECTION_ADVICE,
    SELECTION_DEVELOPMENT_ADVICE: ReportSections.SELECTION_DEVELOPMENT_ADVICE,
    DEVELOPMENT_ADVICE: ReportSections.DEVELOPMENT_ADVICE
};

export default EditableReportSections;
